import axios from "axios";
import { toastError } from "shared/utils";
import { signOut } from "../../redux/actions/auth";

const goApiInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL_GO, // Default Base URL
  });
const getReduxState = () => {
  try {
    const store = require("../../redux").default; 
    return store.getState();
  } catch (error) {
    console.error("Error accessing Redux store:", error);
    return {};
  }
};

const getTenantId = () => {
    const state = getReduxState();
    return state.auth?.user?.tenant_id || localStorage.getItem("tenant_id") || process.env.REACT_APP_TENANT_ID;
  };

const getHeaders = () => {
  const state = getReduxState();
  const token = state.auth?.user?.token || localStorage.getItem("token");
    let reqHeaders = {
    "x-tenant-id": getTenantId(),
    Authorization: token ? `Bearer ${token}` : "",
    "x-referrer": "Kisshtadminpanel",
  };
  return reqHeaders;

};

// Request Interceptor 
goApiInstance.interceptors.request.use(
  (req) => {
    req.headers = { ...req.headers, ...getHeaders() };
    return req;
  },
  (error) => Promise.reject(error)
);



// Response Interceptor - Handles token mismatch (`401 Unauthorized`)
goApiInstance.interceptors.response.use(
  (response) => {
    if ([200, 201, 0].includes(response?.status) || [200, 201, 0].includes(response?.data?.response_code)) {
      return response.data; 
    }

    if (response?.status === 500) {
      return response;
    }
    return Promise.reject(response.data);
  },
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Token mismatch detected! Logging out...");
      try {
        const store = require("../../redux").default;
        store.dispatch(signOut());
      } catch (dispatchError) {
        console.error("Error dispatching signOut action:", dispatchError);
      }
    }
    if (error.response?.status === 403) {
      toastError("You are not authorized to access this resource");
    }
    return Promise.reject(error.response?.data?.error);
  }
);

export default goApiInstance;
